/**
 * Console-side mapping of Temporal workflow type names to human-readable
 * labels, mirroring the backend `internal/workflowstatus/descriptors.go`
 * registry. The backend resolves the label and includes it in the SSE
 * payload (`workflow_label`); this map is only the fallback for when
 * the payload omits the label.
 */
const WORKFLOW_LABELS: Readonly<Record<string, string>> = {
  GenerateOfferWorkflow: 'Generate Offer',
  WatermarkInvoiceAttachmentsWorkflow: 'Watermark Invoice Attachments',
  SendInvoiceWorkflow: 'Send Invoice',
};

export function workflowLabel(workflowType: string): string {
  return WORKFLOW_LABELS[workflowType] ?? workflowType;
}
